import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import PortfolioGallery from '../components/PortfolioGallery';
import ClientLogos from '../components/ClientLogos';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import HomeDynamicSection from '../components/HomeDynamicSection';

const BUILTIN_COMPONENTS = {
  hero: Hero,
  about: AboutSection,
  services: ServicesSection,
  portfolio: PortfolioGallery,
  clients: ClientLogos,
  contact: ContactForm,
};

const DEFAULT_SECTIONS = [
  { sectionKey: 'hero', order: 0, enabled: true },
  { sectionKey: 'about', order: 1, enabled: true },
  { sectionKey: 'services', order: 2, enabled: true },
  { sectionKey: 'portfolio', order: 3, enabled: true },
  { sectionKey: 'clients', order: 4, enabled: true },
  { sectionKey: 'contact', order: 5, enabled: true },
];

function Home() {
  const [sections, setSections] = useState(DEFAULT_SECTIONS);
  const [homeDynamicPages, setHomeDynamicPages] = useState([]);

  useEffect(() => {
    fetch('/api/sections')
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data?.length > 0) {
          setSections(d.data.sort((a, b) => a.order - b.order));
        }
      })
      .catch(() => {});

    // Load Dynamic Pages that show on Home
    fetch('/api/dynamic-pages/home-sections')
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data?.length > 0) {
          setHomeDynamicPages(d.data);
        }
      })
      .catch(() => {});
  }, []);

  // Build dynamic pages map by key for ordering
  const dynamicMap = {};
  homeDynamicPages.forEach(page => {
    dynamicMap[`dynamic-${page.slug}`] = page;
  });

  // Merge built-in sections + dynamic pages, sort by order
  const allItems = [
    ...sections.filter(s => s.enabled).map(s => ({ ...s, _type: 'builtin' })),
    ...homeDynamicPages.map(p => ({
      sectionKey: `dynamic-${p.slug}`,
      order: p.homeOrder ?? 99,
      enabled: true,
      _type: 'dynamic',
      _page: p,
    })),
  ].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <main>
      {allItems.map(item => {
        if (item._type === 'builtin') {
          const Component = BUILTIN_COMPONENTS[item.sectionKey];
          return Component ? <Component key={item.sectionKey} /> : null;
        }
        if (item._type === 'dynamic' && item._page) {
          return <HomeDynamicSection key={item.sectionKey} page={item._page} />;
        }
        return null;
      })}
      <Footer />
    </main>
  );
}

export default Home;
